import { render, staticRenderFns } from "./prePayFeeDeductionDetail.vue?vue&type=template&id=010ae79a&scoped=true"
import script from "./prePayFeeDeductionDetail.vue?vue&type=script&lang=js"
export * from "./prePayFeeDeductionDetail.vue?vue&type=script&lang=js"
import style0 from "./prePayFeeDeductionDetail.vue?vue&type=style&index=0&id=010ae79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ae79a",
  null
  
)

export default component.exports